const ListPlaceload = () => {
    return (
        <div className="placeload list-placeload">
            <div className="header">
                <div className="content-shape loads"></div>
            </div>
            <div className="body">
                <div className="flex-block">
                    {/* <div className="img loads"></div> */}
                    <div className="inner-wrap">
                        <div className="content-shape loads"></div>
                        <div className="content-shape loads"></div>
                    </div>
                </div>
                <div className="flex-block">
                    {/* <div className="img loads"></div> */}
                    <div className="inner-wrap">
                        <div className="content-shape loads"></div>
                        <div className="content-shape loads"></div>
                    </div>
                </div>
                <div className="flex-block">
                    {/* <div className="img loads"></div> */}
                    <div className="inner-wrap">
                        <div className="content-shape loads"></div>
                        <div className="content-shape loads"></div>
                    </div>
                </div>
                <div className="flex-block">
                    {/* <div className="img loads"></div> */}
                    <div className="inner-wrap">
                        <div className="content-shape loads"></div>
                        <div className="content-shape loads"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListPlaceload;
